import React, { useState } from 'react';
import { useLanguage } from '../../../context/LanguageContext';

export const FaqTab = ({ items }) => {
  const { t } = useLanguage();
  const [openIndex, setOpenIndex] = useState(0);

  const popularQuestions = [
    { q: t('cabinetFaq.q1'), a: t('cabinetFaq.a1') },
    { q: t('cabinetFaq.q2'), a: t('cabinetFaq.a2') },
    { q: t('cabinetFaq.q3'), a: t('cabinetFaq.a3') },
    { q: t('cabinetFaq.q4'), a: t('cabinetFaq.a4') },
    { q: t('cabinetFaq.q5'), a: t('cabinetFaq.a5') },
    { q: t('cabinetFaq.q6'), a: t('cabinetFaq.a6') },
    { q: t('cabinetFaq.q7'), a: t('cabinetFaq.a7') },
    { q: t('cabinetFaq.q8'), a: t('cabinetFaq.a8') },
    { q: t('cabinetFaq.q9'), a: t('cabinetFaq.a9') },
    { q: t('cabinetFaq.q10'), a: t('cabinetFaq.a10') }
  ];

  const faqItems = items && items.length > 0 ? items : popularQuestions;

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div>
      <div className="dash-title-block">
        <h2 className="dash-title">{t('dashboard.faqTitle')}</h2>
        <p className="dash-subtitle">{t('cabinetFaq.subtitle')}</p>
      </div>

      <div className="faq-modern-list">
        {faqItems.map((item, index) => (
          <div
            key={index}
            className={`faq-modern-item ${openIndex === index ? 'open' : ''}`}
          >
            <button
              className="faq-modern-question"
              onClick={() => toggle(index)}
              aria-expanded={openIndex === index}
            >
              <span className="faq-modern-q-icon">
                <i className="fas fa-question-circle"></i>
              </span>
              <span className="faq-modern-q-text">{item.question || item.q}</span>
              <span className="faq-modern-toggle">
                <i className={`fas fa-chevron-${openIndex === index ? 'up' : 'down'}`}></i>
              </span>
            </button>
            <div
              className="faq-modern-answer"
              style={{
                maxHeight: openIndex === index ? '500px' : '0',
                opacity: openIndex === index ? 1 : 0,
                padding: openIndex === index ? '0 20px 20px 56px' : '0 20px 0 56px'
              }}
            >
              <p>{item.answer || item.a}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="faq-support-box">
        <div className="faq-support-content">
          <div className="faq-support-icon">
            <i className="fas fa-headset"></i>
          </div>
          <div>
            <h3>{t('cabinetFaq.supportTitle')}</h3>
            <p>{t('cabinetFaq.supportText')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqTab;
